<template>
	<div class="qingwu">
		<el-form label-width="200px" ref="info" :rules="rules" :model="info">
			<el-form-item label="0.01元等于多少金币" prop="ad_index">
				<el-input type="number" placeholder="请输入金币数量" v-model="info.ad_index"></el-input>
			</el-form-item>
			<el-form-item label="低区间看广告占比%" prop="ad_low_min">
				<el-input type="number" placeholder="请输入低区间看广告占比" v-model="info.ad_low_min">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="低区间看广告获得金币-最大值" prop="ad_low_max">
				<el-input type="number" placeholder="请输入低区间看广告获得金币-最大值" v-model="info.ad_low_max">
				</el-input>
			</el-form-item>
			<el-form-item label="高区间看广告占比%" prop="ad_high_min">
				<el-input type="number" placeholder="请输入高区间看广告占比" v-model="info.ad_high_min">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="高区间看广告获得金币-最大值" prop="ad_high_max">
				<el-input type="number" placeholder="请输入高区间看广告获得金币-最大值" v-model="info.ad_high_max">
				</el-input>
			</el-form-item>
			<el-form-item label="3天内同一ip登录账号数量" prop="ad_ip">
				<el-input type="number" placeholder="请输入数量" v-model="info.ad_ip">
				</el-input>
			</el-form-item>
			<el-form-item label="50米内设备数量" prop="ad_loca">
				<el-input type="number" placeholder="请输入50米内设备限制数量" v-model="info.ad_loca">
				</el-input>
			</el-form-item>
			<el-form-item label="广告长度" prop="ad_length">
				<el-input type="number" placeholder="请输入广告长度" v-model="info.ad_length">
				</el-input>
			</el-form-item>
			<el-form-item label="点击率" prop="ad_click">
				<el-input type="number" placeholder="请输入点击率" v-model="info.ad_click">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="用户每天广告总次数" prop="ad_defaule">
				<el-input type="number" placeholder="请输入用户每天广告总次数" v-model="info.ad_defaule">
				</el-input>
			</el-form-item>
			<el-form-item label="10分钟内可看广告次数" prop="ad_10min">
				<el-input type="number" placeholder="请输入10分钟广告次数" v-model="info.ad_10min">
				</el-input>
			</el-form-item>
			<el-form-item label="30分钟内可看广告次数" prop="ad_30min">
				<el-input type="number" placeholder="请输入30分钟广告次数" v-model="info.ad_30min">
				</el-input>
			</el-form-item>
			<el-form-item label="1小时内可看广告次数" prop="ad_1hour">
				<el-input type="number" placeholder="请输入1小时广告次数" v-model="info.ad_1hour">
				</el-input>
			</el-form-item>
			<el-form-item label="广告间隔时常" prop="ad_gap">
				<el-input type="number" placeholder="广告间隔时常" v-model="info.ad_gap">
					<template slot="append">秒</template>
				</el-input>
			</el-form-item>
			<el-form-item label="上级分成" prop="ad_rate">
				<el-input type="number" placeholder="请输入上级分成" v-model="info.ad_rate">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label-width="160px">
				<el-button type="primary" @click="submitForm('info')">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				info: {},
				rules: {
					ad_index: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_low_min: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_low_max: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_high_min: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_high_max: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_ip: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_loca: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_length: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_click: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_defaule: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_rate: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_10min: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_30min: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_1hour: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					ad_gap: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}]
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			submitForm: function(e) {
				this.$refs[e].validate(res => {
					if (res) {
						// Http 请求
						this.$post(this.$api.advertisementConfig, this.info).then(postRes => {
							if (postRes.code == 200) {
								this.$message.success("编辑成功");
								this.get_config();
							} else {
								this.$message.error("编辑失败");
							}
						});
					}
				});
			},
			get_config() {
				this.$get(this.$api.advertisementConfig).then(res => {
					if (res.data != null) {
						this.info = res.data;
					}
				});
			},
		},
		created() {
			this.get_config();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>

</style>